module.exports = __webpack_public_path__ + "img/icon-heart.4871099a.svg";